import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { CREATOR_VIDEO_FEED } from "../constants/urls";
import GlipHeader from "../components/mobile/GlipHeader";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import map from '../assets/map_image.svg';
import valo from '../assets/valo_image.png';

const user_map = {
  kapa: 127872,
  lightningfast: 127936,
  HellrangeR: 127877,
  skillZ: 127870,
  SkRossi: 127874,
  momos: 123942
};
// install Swiper modules

const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
`;

const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
`;

const Button = styled.button`
    background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
    padding: 12px 16px;
    border-radius: ${props => props.rounded ? '10000px': '8px'};
    font-size: 14px;
    color: #fff;
    border: 0px solid blue;
    width: 145px;
    -webkit-transition-duration: 0.4s; /* Safari */
    transition-duration: 0.4s;
    position: relative;
    overflow: hidden;
    cursor: pointer;
`;



export default function RemoteGlipPage(props) {

  const history = useHistory();
  const location = useLocation();

  const glip = async (username) => {
    console.log(username)
    await fetch('https://be.namasteapis.com/api/v1/remote-glip/', {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      body: JSON.stringify({userId: user_map[username]}),
      // Adding headers to the request
        headers: {
          "Content-type": "application/json; charset=UTF-8"
      }
      });
  }

  const card_list = ['kapa', 'lightningfast', 'HellrangeR', 'skillZ', 'SkRossi', 'momos'].map((item, index) => {
    return (
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: 12}}>
        <span>{item}</span>
        <Button className={'button'} onClick={() => glip(item)}>glip!</Button>
      </div>
    );
  });
 

  return (
    <>
      <Mobile>
        <GlipHeader backPress={() => console.log('damn')} title={'Remote Glip'}/>
        <div style={{padding: 12}}>
          {card_list}
        </div>        
      </Mobile>
      <Desktop>
        <GlipHeader backPress={() => console.log('damn')} title={'Remote Glip'}/>
        <div style={{padding: 12}}>
          {card_list}
        </div>        
      </Desktop>
    </>
  );
}

